import http from "../../http-common";
/**
 * Author : AndréK
 * 26/08/2022
*/

//Detent
const createDetent = (data) => {
    return http.post("/Detent/InsertDetent", data);
};

const getDetent = (data) => {
    return http.post("/Detent/FilterDetent", data);
};

const updateDetent = (data) => {
    return http.post("/Detent/UpdateDetent", data);
};

//Address
const createDetentAddress = (data) => {
    return http.post("/Detent/InsertDetentAddress", data);
};

const getDetentAddress = (data) => {
    return http.post("/Detent/FilterDetentAddress", data);
};

const updateDetentAddress = (data) => {
    return http.post("/Detent/UpdateDetentAddress", data);
};

//Email
const createDetentEmail = (data) => {
    return http.post("/Detent/InsertDetentEmail", data);
};

const getDetentEmail = (data) => {
    return http.post("/Detent/FilterDetentEmail", data);
};

const updateDetentEmail = (data) => {
    return http.post("/Detent/UpdateDetentEmail", data);
};

//Phone
const createDetentPhone = (data) => {
    return http.post("/Detent/InsertDetentPhone", data);
};

const getDetentPhone = (data) => {
    return http.post("/Detent/FilterDetentPhone", data);
};

const updateDetentPhone = (data) => {
    return http.post("/Detent/UpdateDetentPhone", data);
};


export default {
    createDetent,
    getDetent,
    updateDetent,
    createDetentAddress,
    getDetentAddress,
    updateDetentAddress,
    createDetentEmail,
    getDetentEmail,
    updateDetentEmail,
    createDetentPhone,
    getDetentPhone,
    updateDetentPhone
};
